import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import AuthLayout from "./layouts/AuthLayout";
import { lazy, Suspense } from "react";

const PageLoader = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <div className="text-lg text-gray-500">Loading...</div>
  </div>
);

const withSuspense = (Component: React.LazyExoticComponent<React.ComponentType<any>>) => (
  <Suspense fallback={<PageLoader />}>
    <Component />
  </Suspense>
);

const LoginPage = lazy(() => import("@/pages/login/LoginPage"));
const StatsPage = lazy(() => import("@/pages/stats/StatsPage"));
const ProfilePage = lazy(() => import("@/pages/profile/ProfilePage"));

export const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      { path: "/", element: <Navigate to="/stats" replace /> },
      { path: "/login", element: withSuspense(LoginPage) },
      {
        element: <AuthLayout />,
        children: [
          { path: "/stats", element: withSuspense(StatsPage) },
          { path: "/profile", element: withSuspense(ProfilePage) },
        ],
      },
    ],
  },
]);
